import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { SessionService } from './session.service';

export let browserRefresh = false;

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(private sessionService: SessionService,
                private router: Router) {
      this.sessionService
          .loadSession();
    }

    canActivate(): boolean {
        let can = true;

        if (!this.sessionService.isValid()) {
            this.router.navigate(['login']);
            can = false;
        }

        return can;
    }
}
